/**
 * Browser (IIFE/CDN) entry — Auth0. Built to foundation-sdk.browser.auth0.global.js.
 *
 * Registers the same factory the `foundation-sdk/auth0` npm entry exports. Do not
 * re-implement the provider here: this file previously held a hand-copied variant
 * that drifted and silently shipped without handleCallback, which Auth0's
 * loginWithRedirect flow requires to exchange the authorization code.
 *
 * Register explicitly rather than relying on auth-auth0's own auto-registration
 * side effect. package.json "sideEffects" only whitelists the built ./dist/auth-*
 * paths, so esbuild considers the source module side-effect-free and drops a
 * bare `import './auth-auth0'` — taking auth0-spa-js and the whole provider with it.
 */
import { registerAuthProvider } from './auth'
import { auth0Auth } from './auth-auth0'

registerAuthProvider('auth0', auth0Auth)

export { createFoundation } from './foundation'
